import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/data";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { fadeUp, stagger, staggerChild } from "../lib/motion";
import {
  getSavedRegion,
  getCurrencyForRegion,
  formatPrice,
} from "../lib/currency";

const Icon = ({ name, className }) => {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
};

export default function Services() {
  const [region, setRegion] = useState(getSavedRegion());
  const currency = getCurrencyForRegion(region);
  useEffect(() => {
      const handleRegionChange = (event) => {
        setRegion(event.detail.region);
      };
  
      window.addEventListener(
        "solksites-region-change",
        handleRegionChange
      );
  
      return () => {
        window.removeEventListener(
          "solksites-region-change",
          handleRegionChange
        );
      };
    }, []);

  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Everything you need. Nothing you don't."
        subtitle="We offer a range of services to help you build, grow, and maintain your online presence. Take a look below to see how we can help your business succeed online."
      >
      </PageHero>

      <section className="pb-24" data-testid="services-grid">
        <div className="container-page">
          <motion.div {...stagger(0.05)} className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <motion.div key={s.slug} {...staggerChild}>
                <Link
                  to={s.link ? `/${s.link}` : `/services/${s.slug}`}
                  className="card-surface card-hover p-8 block group h-full"
                  data-testid={`service-item-${s.slug}`}
                >
                  <div className="h-12 w-12 rounded-xl bg-blue-50 dark:bg-blue-500/10 flex items-center justify-center text-blue-600 dark:text-blue-400">
                    <Icon name={s.icon} className="h-5 w-5" />
                  </div>
                  <h3 className="mt-6 text-xl font-semibold text-slate-900 dark:text-white">{s.title}</h3>
                  <p className="mt-2 text-sm text-blue-600 dark:text-blue-400 font-medium">{s.tagline}</p>
                  <p className="mt-3 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{s.shorts[currency]}</p>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-slate-900 dark:text-white group-hover:gap-2 group-hover:text-blue-600 transition-all">
                    Learn more <ArrowUpRight className="h-4 w-4" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
